import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { SeFeIconModule, seFeIconShareAndroidFill } from 'se-fe-icon'
import { SeFeToastModule } from 'se-fe-toast'
import { SeFeTranslationsLoader, SeFeTranslationsModule } from 'se-fe-translations'
import { RegistrationCardComponent } from './registration-card/registration-card.component'

@NgModule({
  imports: [
    CommonModule,
    SeFeIconModule.include([seFeIconShareAndroidFill]),
    SeFeToastModule,
    SeFeTranslationsModule.forChild('se-registration/ui-registration-card/assets')
  ],
  declarations: [
    RegistrationCardComponent
  ],
  exports: [
    RegistrationCardComponent
  ],
})
export class SeRegistrationUiRegistrationCardModule {
  constructor(public translationsLoader: SeFeTranslationsLoader) {}
}
